import { apiURL } from '../config';
import { BlogResponse } from '../models/page';

export const fetchPosts = async (
  current_lang: string = '',
  current_page?: number
): Promise<BlogResponse> => {
  return fetch(
    `${apiURL}${current_lang}blog${current_page ? `?page=${current_page}` : ''}`
  )
    .then((res) => res.json())
    .catch((e) => Promise.reject(e));
};
